import { h } from "preact";
import "./Testimonials.css";

export function Testimonials() {
  return (
    <section class="testimonials-section">
      <h1>Customer Testimonials</h1>
      <figure class="testimonials-quote">
        <blockquote>
          “As someone who’s all about supporting local and making life easier, I
          love what EZ Coupons is doing. It’s totally free for users, super
          simple to sign up, and you get access to amazing deals from local
          Utah businesses right away! Whether you're a shopper looking to save
          or a business owner wanting more exposure, EZ Coupons brings real
          value to both sides. Highly recommend!”
        </blockquote>
        <figcaption>– Tysen C</figcaption>
      </figure>
    </section>
  );
}
